module.exports = __webpack_public_path__ + "img/cta-banner-2.544c0479.png";